import { render, staticRenderFns } from "./socketUpdates.vue?vue&type=template&id=02962d73&"
import script from "./socketUpdates.vue?vue&type=script&lang=js&"
export * from "./socketUpdates.vue?vue&type=script&lang=js&"
import style0 from "./socketUpdates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "socketUpdates.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VSnackbar,
})
